(() => {
  const onReady = (fn) => document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fn)
    : fn();

  onReady(() => {
    const cfg = window.ECellStreetUX || {};
    const productInfo = document.querySelector('product-info[data-ec-after-add-eligible]');
    const localEligible = productInfo?.dataset?.ecAfterAddEligible === 'true';
    const eligible = cfg.afterAddEligible === true || localEligible;
    const behavior = cfg.afterAddBehavior || 'prompt';
    const targetUrl = cfg.afterAddUrl || '/collections/all';
    const redirectDelay = Number(cfg.afterAddDelay || 700);
    const promptTitle = cfg.promptTitle || 'Added to cart';
    const promptText = cfg.promptText || 'Add more festive favourites before checkout.';
    const shopMoreText = cfg.shopMoreText || 'Shop more, save more';

    if (behavior === 'stay') return;

    const PENDING_KEY = 'ecellstreet_shop_more_pending';
    const markPending = () => {
      try { sessionStorage.setItem(PENDING_KEY, '1'); } catch (_) {}
      document.documentElement.dataset.ecShopMorePending = 'true';
    };
    const isPending = () => {
      try {
        if (sessionStorage.getItem(PENDING_KEY) === '1') return true;
      } catch (_) {}
      return document.documentElement.dataset.ecShopMorePending === 'true';
    };
    const clearPending = () => {
      try { sessionStorage.removeItem(PENDING_KEY); } catch (_) {}
      delete document.documentElement.dataset.ecShopMorePending;
    };

    const isMainAddForm = (form) => {
      if (!form || !form.matches?.('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) return false;
      if (productInfo) return productInfo.contains(form);
      return !!form.closest('.m-product-info, .m-main-product, [data-product-id]');
    };

    const buildBox = () => {
      const box = document.createElement('div');
      box.className = 'ec-cart-shop-more ec-cart-shop-more--js';
      box.dataset.ecCartShopMore = 'true';
      box.innerHTML = `
        <strong class="ec-cart-shop-more__title"></strong>
        <span class="ec-cart-shop-more__message"></span>
        <a class="ec-cart-shop-more__button"></a>`;
      box.querySelector('.ec-cart-shop-more__title').textContent = promptTitle;
      box.querySelector('.ec-cart-shop-more__message').textContent = promptText;
      const link = box.querySelector('.ec-cart-shop-more__button');
      link.textContent = shopMoreText;
      link.href = targetUrl;
      return box;
    };

    const injectDrawerUpsell = () => {
      if (!isPending()) return false;
      const drawer = document.querySelector('m-cart-drawer, .m-cart-drawer');
      if (!drawer || !drawer.classList.contains('m-cart-drawer--active')) return false;

      if (behavior === 'redirect') {
        clearPending();
        window.setTimeout(() => { window.location.href = targetUrl; }, redirectDelay);
        return true;
      }

      const existing = drawer.querySelector('.ec-cart-shop-more');
      if (existing) {
        existing.style.display = '';
        clearPending();
        return true;
      }

      const host = drawer.querySelector('.m-cart-drawer__footer--wrapper') ||
                   drawer.querySelector('#MinimogCartDrawerFooter') ||
                   drawer.querySelector('.m-cart-drawer__footer') ||
                   drawer.querySelector('.m-cart-drawer__body');
      if (!host) return false;

      host.prepend(buildBox());
      clearPending();
      return true;
    };

    const retryInject = () => {
      let tries = 0;
      const timer = window.setInterval(() => {
        tries += 1;
        if (injectDrawerUpsell() || tries >= 40) window.clearInterval(timer);
      }, 125);
    };

    // Arm on the actual PDP add action. This does not depend on Minimog's event payload.
    document.addEventListener('submit', (event) => {
      if (eligible && isMainAddForm(event.target)) {
        markPending();
        retryInject();
      }
    }, true);

    document.addEventListener('click', (event) => {
      const btn = event.target?.closest?.('button[name="add"], .m-add-to-cart, [data-add-to-cart]');
      if (!btn || btn.disabled) return;
      const form = btn.closest('form');
      if (eligible && isMainAddForm(form)) {
        markPending();
        retryInject();
      }
    }, true);

    // Watch the drawer itself because Minimog swaps its inner HTML after AJAX add.
    const watchDrawer = () => {
      const drawer = document.querySelector('m-cart-drawer, .m-cart-drawer');
      if (!drawer || !window.MutationObserver) return false;
      const obs = new MutationObserver(() => {
        if (isPending()) injectDrawerUpsell();
      });
      obs.observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
      return true;
    };
    if (!watchDrawer()) {
      let tries = 0;
      const t = window.setInterval(() => {
        tries += 1;
        if (watchDrawer() || tries > 40) window.clearInterval(t);
      }, 125);
    }

    // Extra hooks for Minimog / app variants. Safe because they only act when this eligible PDP was armed.
    document.addEventListener('cart:updated', () => { if (isPending()) retryInject(); });
    document.addEventListener('cart:refresh', () => { if (isPending()) retryInject(); });
    document.addEventListener('product-ajax:added', () => { if (isPending()) retryInject(); });
  });
})();
